import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@visalex/core';

import { TFunction } from 'i18next';

import styles from '../FreeConsultation.module.scss';

export const createCaption = (i: number, t: TFunction) => {
  const tooltipContent = (
    <div className={styles['free-consultation__tooltip']}>
      <h3>{t(`free-consultation.pages.${i}.tooltip-title`)}</h3>
      <p>{t(`free-consultation.pages.${i}.tooltip-description`)}</p>
    </div>
  );

  return (
    <Tooltip
      enablePortal
      tooltipContent={tooltipContent}
      direction="top"
      className={styles['free-consultation__tooltip__holder']}
      menuClassName="mt-n5"
    >
      <div className={styles['free-consultation__caption']}>
        <FontAwesomeIcon icon="info-circle" />
        <span>{t('free-consultation.why-we-ask')}</span>
      </div>
    </Tooltip>
  );
};
